import { type ComponentPropsWithoutRef, forwardRef, useState } from 'react';

import { Palette } from '@air/next-icons';

import { CUSTOM_FIELD_MODAL_OPTION_COLOR_MENU_TRIGGER } from '~/constants/testIDs';

type CustomFieldModalColorMenuTriggerProps = {
  selectedColor: string;
  fontHex: string;
} & ComponentPropsWithoutRef<'div'>;

export const CustomFieldModalColorMenuTrigger = forwardRef<HTMLDivElement, CustomFieldModalColorMenuTriggerProps>(
  ({ selectedColor, fontHex, ...props }: CustomFieldModalColorMenuTriggerProps, ref) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        ref={ref}
        className="absolute top-1/2 left-2 flex size-6 -translate-y-1/2 cursor-pointer items-center justify-center rounded-4 p-0"
        data-testid={CUSTOM_FIELD_MODAL_OPTION_COLOR_MENU_TRIGGER}
        style={{
          backgroundColor: isHovered ? `color-mix(in hsl, ${selectedColor} 90%, black)` : selectedColor,
          color: fontHex,
        }}
        {...props}
      >
        <Palette className="size-4" />
      </div>
    );
  },
);

CustomFieldModalColorMenuTrigger.displayName = 'CustomFieldModalColorMenuTrigger';
